import React from "react";

const BrandLogoMob = ({ height, width }) => {
  return (
    <img
      src={"/images/SZ.png"}
      alt="Brand Logo"
      className="brand-logo"
      height={height || "50px"}
      width={width || "50px"}
    />
  );
};

export default BrandLogoMob;
